import { createContext } from "react";

export const ClientViewContext = createContext({});
